import axiosInstance from "../../translator";
import { actionLogApi } from "../../constants/apis/apiEndpoints";

export const fetchActionLogsList = async (urlParams) => {
  return axiosInstance
    .get(`${actionLogApi?.actionLogsList}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchBetweenDatesLogsList = async (urlParams) => {
  return axiosInstance
    .get(`${actionLogApi?.actionLogsList}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const exportActionLogsApi = async (urlParams) => {
  return axiosInstance
    .get(`${actionLogApi?.actionLogDownload}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
